export default __webpack_public_path__ + "static/media/1768.62f0be10.png";